export default [
  'blur',
  'change',
  'click',
  'contextmenu',
  'dblclick',
  'error',
  'focus',
  'focusin',
  'focusout',
  'input',
  'keydown',
  'keypress',
  'keyup',
  'load',
  'mousedown',
  'mouseup',
  'resize',
  'select',
  'submit',
  'touchcancel',
  'touchend',
  'touchstart',
  'unload'
]
